import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './cotizacion-cantidad_utils';

export const useCotizacionCantidadStore = defineStore('cotizacionCantidadStore', {
  state: () => ({
    cotizacionCantidadList: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllCotizacionCantidadHTTP(params) {
      const result = await api.get(
        `/cotizacion-cantidad?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.cotizacionCantidadList.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    setPage(page) {
      this.page = page;
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
    emptyList() {
      this.cotizacionCantidadList = [];
    },
  },
});
